export default __webpack_public_path__ + "static/media/icon-bno.e218f456.svg";